"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { html, LitElement } from "lit";
import { property, state } from "lit/decorators.js";
import { STCComponentMixin } from "../../common/mixins/stc_component_mixin";
const template = {
  render() {
    return (interaction) => {
      return html`
                <li kind="no-dot" class="bbz">
                    <interaction-feed-item .interaction=${interaction}></interaction-feed-item>
                </li>
            `;
    };
  }
};
export class InteractionFeed extends STCComponentMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.interactions = [];
    this.type = {
      fields: {
        row_1: {
          name: "row_1",
          title: "",
          render_type: "text"
        },
        row_2: {
          name: "row_2",
          title: "",
          render_type: "text"
        },
        row_3: {
          name: "row_3",
          title: "",
          render_type: "text"
        }
      }
    };
    this.settings = {
      messages: {
        state_empty: {
          title: "",
          description: "There are no interactions for this application."
        }
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.fetchInteractions();
  }
  fetchInteractions() {
    const data = this.getAttribute("data-interactions");
    if (data) {
      this.interactions = JSON.parse(data);
    }
  }
  render() {
    return html`
          <vi-list
           class="interactionsFeed"
           mode="item"
           .type=${this.type}
           .settings=${this.settings}
           .input=${this.interactions}
           .template=${template}
         >
         </vi-list>
    `;
  }
}
__decorateClass([
  state()
], InteractionFeed.prototype, "interactions", 2);
customElements.define("interactions-feed", InteractionFeed);
class InteractionFeedItem extends LitElement {
  render() {
    return html`
            <hi-tile>
                <div class="interactionsFeedText">${unsafeHTML(this.interaction.row_1)}</div>
                <div class="interactionsFeedText">${unsafeHTML(this.interaction.row_2)}</div>
                <div class="interactionsFeedText">${unsafeHTML(this.interaction.row_3)}</div>
            </hi-tile>
        `;
  }
}
__decorateClass([
  property()
], InteractionFeedItem.prototype, "interaction", 2);
customElements.define("interaction-feed-item", InteractionFeedItem);
